import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '../hooks/auth';

function PrivateRoute() {
  const { user, isLoading } = useAuth();
  if (isLoading) {
    return null;
  }
  return user ? <Outlet /> : <Navigate to="/" />;
}

export default PrivateRoute;
